import fecha from 'fecha'

/* eslint-disable no-extra-boolean-cast */

export default {
  name: 'BaseDates',
  props: {
    item: {
      type: Object,
      required: true
    },
    showNow: {
      type: Boolean,
      default: false
    },
    years: {
      type: Boolean,
      default: true
    },
    months: {
      type: String,
      default: 'MMM'
    }
  },
  computed: {
    time () {
      return new Date()
    },
    useTime () {
      return this.item.time === 'true'
    },
    start () {
      return this.useTime
        ? this.item.start_time && !!this.item.start_time.length
          ? new Date(this.item.start_time)
          : false
        : this.item.start && !!this.item.start.length
          ? new Date(this.item.start)
          : false
    },
    end () {
      return this.useTime
        ? new Date(this.item.end_time)
        : new Date(this.item.end)
    },
    hasStartTime () {
      return this.item.start_time && !!this.item.start_time.length
    },
    hasEndTime () {
      return this.item.end_time && !!this.item.end_time.length
    },
    now () {
      return this.start < this.time && this.time < this.end
    },
    locale () {
      return this.$store.state.locale
    },
    nowText () {
      return this.$t('general', 'now')
    }
  },
  render (h) {
    // Item has a display date
    if (this.item.display_date) {
      const items = this.item.display_date.split(' - ').map((x) => {
        return h('span', {}, x)
      })
      items.splice(1, 0, h('span', {
        class: 'text-orange-brand'
      }, ' → '))
      return h('div', {}, items)
    } else if (!this.start && !this.hasStartTime && !this.end && !this.hasEndTime) {
      return
    } else if (this.start) {
      const blackText = { class: 'text-inherit' }
      // 2 days in the same month, same year (2020年10月21日-22日)
      // Same year (2020年1月22日-4月18日)
      // Time + same day (2020年12月21日，13:00-20:00)
      // Times, diff days (2020年12月20日-21日，13:00-20:00)

      // start/end times
      const times = []
      if (this.useTime) {
        if (this.hasStartTime) {
          times.push(fecha.format(this.start, 'H:mm'))
        }
        if (this.hasEndTime) {
          times.push(fecha.format(this.end, 'H:mm'))
        }
      }

      const sameYear = this.end && (this.start.getFullYear() === this.end.getFullYear())
      const sameMonth = sameYear && (this.start.getMonth() === this.end.getMonth())
      const sameDay = sameYear && sameMonth && (this.start.getDate() === this.end.getDate())

      if (this.locale === 'cn') {
        let fullStr = fecha.format(this.start, 'YYYY年M月D日')

        if (this.end) {
          const ends = []

          if (!sameYear) {
            ends.push('YYYY年')
          }
          if (!sameMonth) {
            ends.push('M月')
          }
          if (!sameDay) {
            ends.push('D日')
          }

          if (ends.length) {
            fullStr += ` → ${fecha.format(this.end, ends.join(''))}`
          }
        }

        if (times.length) {
          fullStr += `, ${times.join('-')}`
        }

        return h('div', {
          class: this.$attrs.class
        }, [
          h('span', blackText, fullStr)
        ])
      }

      // return early if only one date
      if (sameYear && sameMonth && sameDay && !this.end) {
        return h('div', {
          class: this.$attrs.class
        }, [h('span', blackText, fecha.format(this.start, `D ${this.months} YYYY`))])
      }

      // english date format
      const format = []
      const endFormat = []

      if (!this.end) {
        format.push('D', this.months, 'YYYY')
      } else {
        if (!sameDay) {
          format.push('D')
        }
        if (!sameMonth) {
          format.push(this.months)
        }
        if (!sameYear) {
          this.years && format.push('YYYY')
        }
      }

      const children = []

      if (format.length) {
        children.push(
          h('span', blackText, fecha.format(this.start, format.join(' ')))
        )
      }

      if (this.end) {
        if (!sameMonth || !sameDay) {
          endFormat.unshift(
            endFormat.length ? `${this.months},` : this.months
          )
          endFormat.unshift('D')
        }

        if (this.years && endFormat.length > 1) {
          endFormat.push('YYYY')
        }

        if (!format.length) {
          endFormat.unshift(`D ${this.months} YYYY`)
        }

        if (format.length && endFormat.length) {
          children.push(h('span', { class: 'text-orange-brand' }, ' → '))
        }

        if (times.length) {
          endFormat[endFormat.length - 1] += ','
          endFormat.push(times.join('-'))
        }

        children.push(
          h('span', blackText, fecha.format(this.end, endFormat.join(' ')))
        )
      }
      if (this.now && this.showNow) {
        children.unshift(h('span', this.nowText))
      }
      return h('div', {
        class: this.$attrs.class
      }, children)
    } else {
      return
    }
  }
}
